import { NgClass, NgIf } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'sd-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgIf],
  encapsulation: ViewEncapsulation.None,
})
export class FormFieldComponent implements AfterViewInit {
  value: string;
  @Input() label: string;
  // вешает класс 'form-field-label_shrinked' на label независимо от значения в input
  @Input() isShrinked: boolean;

  @ViewChild('labelWrapper')
  labelWrapper: ElementRef;

  constructor(private cd: ChangeDetectorRef) {}

  @HostListener('input', ['$event'])
  onInput(e: Event): void {
    this.value = (e.target as HTMLInputElement).value;
  }

  ngAfterViewInit(): void {
    this.value = this.labelWrapper.nativeElement.children[0]?.value;
    this.cd.detectChanges();
  }
}
